import React from 'react';
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import logo from '../../../../images/thoot.png';
import { resetPass, checkToken } from "./actions";
import Redirect from "react-router-dom/es/Redirect";
import SiteFoot from "../../../../shared/components/footer";

class ResetPassword extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            password: '',
            rePassword: '',
            saveButtonDisable: true,
            validation: {
                password: {valid: undefined, message: ''},
                re_password: {valid: undefined, message: ''}
            }
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.onChangePasswords = this.onChangePasswords.bind(this);
        this.validatePassword = this.validatePassword.bind(this);
    }
    componentDidMount () {
        document.title = "Reset Password";
        const { match: { params } } = this.props.params;
        this.props.check(params);
    }

    onChangePasswords (key, value) {
        let validationObject = this.state.validation;
        let validation;
        if (key === 'password') {
            validation = this.validatePassword(value);
            const validationRe = this.validatePassword(this.state.rePassword, true);
            validationObject.password = {
                valid: validation,
                message: (!validation) ? 'Password must be at least 6 character.' : ''
            }
            validationObject.re_password = {
                valid: validationRe,
                message: (!validationRe) ? 'Your passwords do not match.' : ''
            }
        } else if (key === 'rePassword') {
            validation = this.validatePassword(value, true);
            validationObject.re_password = {
                valid: validation,
                message: (!validation) ? 'Your passwords do not match.' : ''
            };
        }
        let notValid = false;
        let thisState = this.state.validation;
        if (thisState.password === undefined || !thisState.password.valid || thisState.re_password === undefined || !thisState.re_password.valid ) {
            notValid = true;
        }
        this.setState({
            [key]: value,
            validation: validationObject,
            saveButtonDisable: notValid
        })

    }

    validatePassword(value, repeat = false) {
        let returnValue = false;
        if (!repeat) {
            if (value && value.length >= 6) {
                returnValue = true;
            }
        } else {
            let firstPassword = this.state.password;
            if (firstPassword === value) {
                returnValue = true;
            }
        }
        return returnValue;
    }

    handleSubmit () {
        var {password} = this.state;
        const { match: { params } } = this.props.params;
        const userId = params.userId;
        this.props.reset({password: password, user_id: userId });
    }

    componentWillReceiveProps(nextProps) {
        if(!this.props.store.error && nextProps.store.error) {
            this.setState({validation: {...this.state.validation, password: {valid: false, message: nextProps.store.error},}})
        }
    }

    render () {
        return (
            <div className="sign-in">
                { (this.props.store.resetSuccess === true) && <Redirect to="/sign-in" /> }
                <div className="sign-in__container">
                    <div className="main-block sign forgot-password">
                        <div className="main-block__logo">
                            <Link to="/">
                                <img src={logo} alt="Kerenor Booking" width="300"/>
                            </Link>
                        </div>
                        <div className="main-block__form">
                            {
                                this.props.store.checkingToken ?
                                    <form>
                                    <div className="text-field"> {/*add has-error for error styles*/}
                                        <label className="text-field__label" htmlFor="">Password</label>
                                        <input
                                            placeholder="Type password"
                                            type="password"
                                            className="text-field__input"
                                            onChange={(e) => this.onChangePasswords('password', e.target.value )}
                                        />
                                        <span className="error-message">{this.state.validation.password.message}</span>
                                    </div>
                                    <div className="text-field"> {/*add has-error for error styles*/}
                                        <label className="text-field__label" htmlFor="">Confirm password</label>
                                        <input
                                            placeholder="Retype password"
                                            type="password"
                                            className="text-field__input"
                                            onChange={(e) => this.onChangePasswords('rePassword', e.target.value )}
                                        />
                                        <span className="error-message">{this.state.validation.re_password.message}</span>
                                    </div>
                                </form>
                                    :
                                    <h3 className="text-center mb-4">Reset password link is expired.</h3>
                            }
                        </div>
                        <div className="main-block__buttons">
                            {
                                this.props.store.checkingToken && <button
                                    className="btn btn-secondary"
                                    disabled={this.state.saveButtonDisable}
                                    onClick={this.handleSubmit}
                                >
                                    Reset
                                </button>
                            }

                        </div>
                        <SiteFoot className="copyright"/>
                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        store: state.resetPassword
    }
};

const mapDispatchToProps = dispatch => {
    return {
        check: (params) => dispatch(checkToken(params)),
        reset: (params) => dispatch(resetPass(params))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);



// WEBPACK FOOTER //
// ./src/containers/Layouts/Default/ResetPassword/index.js